import styles from "./styles.module.css";

export default function Header({title, onClick}) {
  const tabs = ["fields", "security", "data", "triggers"];

  const tab = (name, index) => (
    <div 
      key={index}
      className={`${(title === name) ? styles.active : ""}`}
      onClick={() => onClick(name)}
    >
      <p className={"nav-text"} >
        {name.charAt(0).toUpperCase() + name.slice(1)}
      </p>
    </div>
  );

  return (
    <div className={styles.section}>
      <div className={styles.header}>
        {tabs.map((cur, index) => tab(cur, index))}
      </div>
    </div>
  )
}